import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * module pickUpRoomRegistration
 * author xuyuxiong
 * description 接房登记
 */
import { fetchList } from '@/api/PMS/houseDeliveryManage/deliveryRegistration';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import deliveryAdd from './add';
import houseDetail from '@/views/PMS/baseInformation/WuyeZiyuanManager/house/detail';
import customerDetail from '@/views/PMS/baseInformation/customer/detail';
import { formatJson } from '@/utils/index';
export default {
  components: {
    deliveryAdd: deliveryAdd,
    houseDetail: houseDetail,
    customerDetail: customerDetail
  },
  data: function data() {
    return {
      customerId: '',
      houseId: '',
      list: [],
      listLoading: false,
      dialogFormVisible: false,
      downloadLoading: false,
      dialogHouseFormVisible: false,
      dialogCustomerFormVisible: false,
      listQuery: {
        limit: 10,
        page: 1,
        houseStatus: 2
      },
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      total: 0,
      title: '',
      deliveryData: {},
      cascaderItem: [],
      floorOption: [],
      buildingOptions: [],
      dates: [],
      multipleSelection: []
    };
  },
  watch: {
    propertyObj: {
      handler: function handler(n, o) {
        this.getList();
      },
      immediate: true
    }
  },
  created: function created() {
    this.cascaderItem = [];
    this.floorOption = [];
    this.buildingOptions = [];
    this.getList();
    this.loadBuiildingTree();
  },
  methods: {
    loadBuiildingTree: function loadBuiildingTree() {
      var _this = this;

      var treeQuery = {
        flag: 2
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this.buildingOptions = response.data.data;
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getList: function getList() {
      var _this2 = this;

      fetchList(this.listQuery).then(function (res) {
        _this2.list = res.data.data;
        _this2.total = res.data.total;
      });
    },
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this3 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this3.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    checkSelectBuild: function checkSelectBuild(val) {
      if (val) {
        this.listQuery.buildingId = '';
        this.cascaderItem = [];
        this.getCascaderItem(this.listQuery.upIdList, this.buildingOptions);

        if (this.cascaderItem.length > 0 && this.cascaderItem[this.cascaderItem.length - 1].flag !== '2') {
          this.$message({
            message: '请选择正确的楼栋',
            type: 'error',
            duration: 3000
          });
          this.listQuery.upIdList = [];
          return;
        }

        this.listQuery.buildingId = this.listQuery.upIdList[this.listQuery.upIdList.length - 1];
      }
    },
    handleUpload: function handleUpload() {
      var _this4 = this;

      this.$confirm('你确定是要导出这些接房登记记录吗, 是否继续?', '提示').then(function () {
        if (_this4.list !== null && _this4.list.length > 0) {
          _this4.downloadLoading = true;
          Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@/vendor/Export2Excel'));
          }).then(function (excel) {
            var tHeader = ['小区名称', '楼栋', '房间代码', '建筑面积', '客户名称', '接房日期'];
            var filterVal = ['areaName', 'buildingName', 'houseCode', 'houseArea', 'customerName', 'statusDate'];
            var data = formatJson(filterVal, _this4.list);
            excel.export_json_to_excel({
              header: tHeader,
              data: data,
              filename: '接房登记记录',
              autoWidth: true,
              bookType: 'xlsx'
            });
            _this4.downloadLoading = false;
          });
        } else {
          _this4.Alert({
            alertType: 'error',
            message: '暂无数据，无法导出!'
          });
        }
      });
    },
    handleFilter: function handleFilter() {
      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = '';
        this.listQuery.endDate = '';
      }

      this.getList();
    },
    deliveryRegistration: function deliveryRegistration() {
      this.deliveryData = {};
      this.dialogFormVisible = true;
      this.title = '交房登记';
    },
    handleUpdate: function handleUpdate(obj) {
      this.dialogFormVisible = true;
      this.deliveryData = {
        id: obj.id,
        houseId: obj.houseId,
        customerId: obj.customerId,
        houseCode: obj.houseCode,
        statusDate: obj.statusDate,
        houseUseArea: obj.houseArea
      };
      this.title = '编辑';
    },
    getRoomDetail: function getRoomDetail(houseId) {
      this.dialogHouseFormVisible = true;
      this.houseId = houseId;
      this.title = '详情';
    },
    getCustomerDetail: function getCustomerDetail(customerId) {
      this.dialogCustomerFormVisible = true;
      this.customerId = customerId;
      this.title = '详情';
    },
    handCancle: function handCancle() {
      this.getList();
      this.dialogFormVisible = false;
      this.dialogHouseFormVisible = false;
      this.dialogCustomerFormVisible = false;
    }
  }
};